import {
  DragEvent,
  DragEventHandler,
  KeyboardEventHandler,
  MouseEventHandler,
  PointerEventHandler,
  ReactNode
} from 'react'

import { BaseGridItem } from 'shared/types/desktop-grid'

import { CellSize } from '../../types/grid.types'

export interface BaseItemProps {
  itemMetaData: BaseGridItem
  cellSize: CellSize
  onDragStart: (itemId: string) => (e: DragEvent<HTMLDivElement>) => void
  onDragEnd?: DragEventHandler<HTMLDivElement>
  onPointerDown?: (itemId: string) => PointerEventHandler<HTMLDivElement>
  onPointerMove?: PointerEventHandler<HTMLDivElement>
  onPointerUp?: PointerEventHandler<HTMLDivElement>
  onPointerCancel?: PointerEventHandler<HTMLDivElement>
  className?: string
  innerClassName?: string
  onClick?: MouseEventHandler<HTMLDivElement>
  onDoubleClick?: MouseEventHandler<HTMLDivElement>
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>
  ariaLabel?: string
  ariaBusy?: boolean
  children?: ReactNode
  disabled?: boolean
  suppressClick?: boolean
  isTouchReorderActive?: boolean
  disableNativeDrag?: boolean
  disableContextMenu?: boolean
}
